/**
 * @param {module} - just like id
 * @param {global} - If all page can show this tip, make it true, otherwise, make it false
 * @param {tooltipEls} - The specific tip content
 * @notice tip element will show at the bottom of the el attribute, so, Make sure the bottom of the Dom that el attribute points to is within visual range
 */
export const pagetips = [
    {
        module: 'menu',
        specifiedRoute: false,
        tooltipEls: [
            {
                el: 'li.zm-submenu',
                content: `Through the keyboard shortcuts (Ctrl + Mouse Left)，You can quickly open a page as a new window.`
            }
        ]
    },
    {
        module: 'task',
        specifiedRoute: '/dashboard/task',
        tooltipEls: [
            {
                el: '#classicTask',
                content: `Welcome to the Morden version of the Task module, the classic version is still retained, you can toggle between them via breadcrumbs and tab pages.
      Feedback is welcome.`
            },
            {
                el: '#taskKeyword',
                content: `The Keyword box supports inputting a Id, Name, Topic, Group, Type, keyword, etc. fields for searching.
      
              Among them, taskId, originaltaskId and topic support accurate search.
              When you search for a complete uuid or topic name in the keyword box, will locate you are looking for these types of data, and then recommend the corresponding search for you. 
              Let's try this!`
            }
        ]
    },
    {
        module: 'request',
        specifiedRoute: '/dashboard/request',
        tooltipEls: [
            {
                el: '#classicRequest',
                content: `Welcome to the Morden version of the Request module, the classic version is still retained, you can toggle between them via breadcrumbs and tab pages.Feedback is welcome.`
            },
            {
                el: '#asyncmq-request__table-header',
                content: `Notice, that the modern version of request page and the classic version use a completely different database.
              So,When you can't query the old historical data in the new page, you can switch to the classic request page to try to query it.`
            }
        ]
    }
]
